/**
 * Firebase Web SDK bootstrap. Initialized once at module load.
 * Exports `auth`, `db`, and `storage` for use across the app.
 *
 * Auth persistence is explicitly set to `browserLocalPersistence` so a
 * signed-in user stays signed in across reloads, tab close/reopen, and
 * browser restarts. The web SDK queues all auth operations until
 * persistence resolves, so fire-and-forget here is safe.
 */
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { env } from './env';

const app = initializeApp({
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
});

export const auth = getAuth(app);
void setPersistence(auth, browserLocalPersistence);
export const db = getFirestore(app);
export const storage = getStorage(app);
